import { css } from 'lit';

export const revisionPageStyles = css`
  pre {
    margin: 0;
    padding: var(--space-3) var(--space-4);
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
    background: var(--surface);
    font-family: var(--font-mono);
    font-size: var(--font-size-md);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }

  /* A persona file, formatted, in the frame of the parameters above it. */
  .markdown.file {
    padding: var(--space-3) var(--space-4);
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
    background: var(--surface-raised);
  }

  h3 {
    margin: var(--space-4) 0 var(--space-2);
    font-size: var(--font-size-ui);
  }

  h3 .muted {
    font-weight: var(--font-weight-normal);
  }
`;
